import { useEffect } from 'react'

const usePreloadImages = (images: string[]) => {
  useEffect(() => {
    for (const image of images) {
      const imageElement = new Image()
      imageElement.src = image
    }
  }, [])

  return null
}

export default usePreloadImages
